import React, { useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { MdAdd, MdDelete } from "react-icons/md";

import { operationGetCarLayers, operationDesvinculaCar } from "~/api";
import CarMap from "../../CarMap";
import AddCarToOperationModal from "./components/AddCarToOperationModal";
import DownloadCar from "./components/DownloadCar";
import "./styles.scss";
import { formatNumber } from "~/utils/format";
import { useOperation } from "~/hooks/useOperation";


const SHOW_LAYERS = 1;
const ADD_CAR_TO_OPERATION_MODAL = "ADD_CAR_TO_OPERATION_MODAL";

const OperationCar = ({ stepLabel, setError}) => {
  const { formatMessage } = useIntl();
  const { operation } = useOperation();
  const [openModal, setOpenModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [carList, setCarList] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);

  const fetchResults = useCallback(() => {
    setLoading(true);

    operationGetCarLayers(operation.id, SHOW_LAYERS)
      .then(({ data }) => {
        setCarList(data.result);

        if (data.result.length > 0) {
          setSelectedCar(data.result[0]);
        }

        setLoading(false);
      })
      .catch(err => {
        setError(
          err?.response?.data?.message || formatMessage({ id: "erro-api" })
        );
      });
  }, [operation.id, formatMessage, setError]);

  useEffect(() => {
    fetchResults();
  }, [fetchResults]);

  const handleDeleteCar = useCallback(
    async b3CarsB3PropostaId => {
      setLoading(true);
      try {
        await operationDesvinculaCar({
          b3_cars_b3_proposta_id: b3CarsB3PropostaId
        });

        if (selectedCar.B3CarsB3Proposta.id === b3CarsB3PropostaId) {
          setSelectedCar(null);
        }

        setCarList(oldCarList => {
          return oldCarList.filter(
            car => car.B3CarsB3Proposta.id !== b3CarsB3PropostaId
          );
        });
      } catch (err) {
        setError(formatMessage({ id: "erro-api" }));
      }

      setLoading(false);
    },
    [formatMessage, setError, selectedCar]
  );

  return (
    <>
      <div className="car">
        <div className="tile is-12 is-vertical">
          <h3>{stepLabel}</h3>
          <p>{formatMessage({ id: "operacao-car-descricao" })}</p>
        </div>
        <div className="tile is-ancestor">
          <div className="tile is-4 is-vertical">
            <div>
            {formatMessage({ id: "opcao-1" })}
            </div>
          
         
          <div className="field">
            <div className="control">
            <DownloadCar reload={fetchResults} setError={setError}>
          </DownloadCar>
            </div>
          </div>
          <div>
          {formatMessage({ id: "opcao-2" })}
            </div>
            <div className="text-label">
        {formatMessage({ id: "upload-zip" })}
      </div>
          <button
              type="button"
              className="add-car-modal-button"
              onClick={() => setOpenModal(ADD_CAR_TO_OPERATION_MODAL)}
            >
              <MdAdd size={20} /> {formatMessage({ id: "cadastrar-car" })}
            </button>

            {loading && <div className="loader" />}

            {!loading && (
              <>
                <h4>{formatMessage({ id: "lista-cars-cadastrados" })}</h4>
                <div className="car-list">
                {(carList.length === 0 || carList[0].PropostasByCar) && (
                  <>{formatMessage({ id: "nenhum-car-cadastrado" })}</>
                )}
                  {       
                    (carList.map((car, carIndex) => (
                      <React.Fragment key={carIndex}>
                        <div
                          className={`car-list-item ${selectedCar &&
                              selectedCar.B3CarsB3Proposta &&
                              selectedCar.B3CarsB3Proposta.id === car.B3CarsB3Proposta.id
                              ? "item-selected"
                              : ""
                            }`}
                          onClick={() => {
                            setSelectedCar(car);
                          }}
                        >
                          {car?.B3Car?.B3Area?.[0]?.area_ha && car?.B3Car?.numero ? (
                            <>
                              <div className={`car-list-item-info`}>
                                <p>
                                  CAR {carIndex + 1} - {formatMessage({ id: "area" })}{" "}
                                  {formatNumber(car.B3Car.B3Area[0].area_ha)} ha
                                </p>
                                <span>
                                  {car.B3Car.numero || formatMessage({ id: "sem-titulo" })}
                                </span>
                              </div>

                              <div className="car-list-item-delete">
                                <MdDelete
                                  className="trash"
                                  size={20}
                                  onClick={() =>
                                    handleDeleteCar(car.B3CarsB3Proposta.id)
                                  }
                                />
                              </div>
                            </>
                          ) : null}
                        </div>
                      </React.Fragment>
                    )))
                  }
                </div>
              </>
            )}
          </div>
          <div className="tile is-8 is-vertical">
            {selectedCar && selectedCar.B3Car && selectedCar.B3Car.B3Area ? (
              <CarMap
                areaInfo={selectedCar.B3Car.B3Area}
                layers={selectedCar.CarLayer}
                className="area-map"
              />
            ) : (
              <div className="area-map map-placeholder">
                {formatMessage({ id: "cadastre-car-para-ver" })}
              </div>
            )}
          </div>
        </div>
      </div>

      {openModal === ADD_CAR_TO_OPERATION_MODAL && (
        <AddCarToOperationModal
          operationId={operation.id}
          setError={setError}
          onSuccess={() => {
            fetchResults();
            setOpenModal(null);
          }}
          onClose={() => setOpenModal(null)}
        />
      )}
    </>
  );
};

export default OperationCar;
